export const GLOBAL_KEYBOARD_SHORTCURS = [
	{title:'Go to tree', type:'global', keyCombination: ['Ctrl','Alt','R'], macKeyCombination: ['Cmd','Option','R']},
	{title:'Go to search', type:'global', keyCombination: ['Ctrl','Alt','S'], macKeyCombination: ['Cmd','Option','S']},
	{title:'Go to builds', type:'global', keyCombination: ['Ctrl','Alt','B'], macKeyCombination: ['Cmd','Option','B']},
	{title:'Login / Logout', type:'global', keyCombination: ['Ctrl','Alt','L'], macKeyCombination: ['Cmd','Option','L']},
	{title:'Keyboard shortcuts index', type:'global', keyCombination: ['Ctrl','Alt','/'], macKeyCombination: ['Cmd','Option','/']}
];
export const PAGE_DEPENDENT_KEYBOARD_SHORTCUTS = [
	{title:'Create new entity', type:'pageDependent', keyCombination: ['Ctrl','Alt','N'], macKeyCombination: ['Cmd','Option','N']}
];


// WEBPACK FOOTER //
// ./services/keyboard_shortcuts_service/keyboard_shortcuts_service.constants.js